import BaseSelector from './BaseSelector'

class AIAssistantSelector extends BaseSelector {
	static fromStoreState(store) {
		return new this(store.aiAssistant)
	}
}

export default AIAssistantSelector
